<template>
	<span>{{address.name}} {{address.street}}, {{address.postal_code}} {{address.city}}</span>
</template>
<script>
import axios from 'axios';
import _ from 'lodash';
export default {
  data: function () {
    return {}
  },
  mounted: function(){
  },
methods: {

},
   props: { address: Object},
  computed: {
   
  },
  
}
</script>
<style scoped>
div {
  margin-left: auto;
  left: auto;
  right: auto;
  line-height: 2;
}
</style>